import { engineUtils } from '../services/EngineUtils.js';
export class CSPSolver {
    constructor(compatibilityFilter, optionValues, options) {
        this.compatibilityFilter = compatibilityFilter;
        this.optionValues = optionValues;
        this.options = options;
    }
    solve(optionPropertyPath, callback) {
        const currentOptionValuesEntries = this.options;
        if (currentOptionValuesEntries.length == 0) {
            const map = new Map();
            const copy = this.optionValues.slice();
            for (const option of this.optionValues) {
                map.set(optionPropertyPath, option);
                copy.shift();
                if (callback(option, map, [copy])) {
                    return;
                }
            }
            return;
        }
        let currentOptionValue;
        let allOptionsValues = new Map();
        const fns = [];
        for (let index = 0; index < currentOptionValuesEntries.length; index++) {
            const [path, optionValues] = currentOptionValuesEntries[index];
            const prevOptionPath = index > 0 ? currentOptionValuesEntries[index - 1][0] : optionPropertyPath;
            const isCurrentOption = index === 0;
            fns.push((prevOptionValue, q) => {
                if (isCurrentOption) {
                    currentOptionValue = prevOptionValue;
                }
                allOptionsValues.set(prevOptionPath, prevOptionValue);
                this.compatibilityFilter.applyOption(prevOptionPath, prevOptionValue);
                return this.compatibilityFilter.filter(path, optionValues);
            });
        }
        const lastEntry = currentOptionValuesEntries[currentOptionValuesEntries.length - 1];
        const lastOptionPath = lastEntry[0];
        engineUtils.cartesian(this.optionValues, fns, (lastOptionValue, q) => {
            allOptionsValues.set(lastOptionPath, lastOptionValue);
            this.compatibilityFilter.applyOption(lastOptionPath, lastOptionValue);
            if (this.compatibilityFilter.anyMath(lastOptionPath)) {
                const exit = callback(currentOptionValue, allOptionsValues, q);
                if (exit === 'Exit') {
                    while (q.length) {
                        q.pop();
                    }
                }
                if (exit === 'ResetFiltersAndContinueFromStart') {
                    while (q.length > 1) {
                        const index = q.length - 1;
                        const prevOptionPath = index > 0 ? currentOptionValuesEntries[index - 1][0] : optionPropertyPath;
                        this.compatibilityFilter.resetOption(prevOptionPath);
                        allOptionsValues.delete(prevOptionPath);
                        q.pop();
                    }
                }
            }
        }, (index) => {
            const prevOptionPath = index > 0 ? currentOptionValuesEntries[index - 1][0] : optionPropertyPath;
            this.compatibilityFilter.resetOption(prevOptionPath);
            allOptionsValues.delete(prevOptionPath);
        });
    }
}
//# sourceMappingURL=CSPSolver.js.map